<template>
	<div>
		<!-- Tabs -->
		<bar-card>
			<sky-tabs v-model="tabValue" :tabList="tabList" @changeTab="changeTab"></sky-tabs>
		</bar-card>

		<!-- 套餐配置 -->
		<set-meal
			ref="setmeal"
			v-show="tabValue == 'setMeal'"
			:setMealGroups="setMealGroups"
			:setMealColumn="setMealColumn"
		></set-meal>
		<!-- 功能配置 -->
		<feature
			ref="feature"
			v-show="tabValue == 'feature'"
			:featureGroups="featureGroups"
			:featureColumn="featureColumn"
		></feature>

		<!-- 自动优惠配置 -->
		<coupons
			ref="coupons"
			v-show="tabValue == 'coupons'"
			:discountGroups="discountGroups"
			:discountColumn="discountColumn"
		></coupons>

		<!-- 套餐价格 -->
		<dialog-form
			:dialogVisible.sync="dialogVisible"
			:attributes="attributes"
			:showBtn="false"
			@close:dialogVisible="val => (dialogVisible = val)"
		>
			<data-list
				slot="main"
				:data="dialogData"
				:columns="dialogColumn"
				:table-style="{ name: 'mixture' }"
			>
			</data-list>
			<div slot="bottom" class="dialog-total">
				<span>总价:{{ dialogTotal }}</span>
				<span>总优惠:{{ preferentialPrice }}</span>
				<span>优惠后总价:{{ preferentialAfterPrice }}</span>
			</div>
		</dialog-form>
	</div>
</template>

<script>
import leftControl from './SaaS/leftControl.vue';
import barCard from '@/components/customPageCard/barCard';
import skyTabs from '@/components/iglobalwin/formComponents/tabs/sky-tabs.vue';
import setMeal from '@/backend/pages/setting/SaaS/setMeal.vue';
import feature from '@/backend/pages/setting/SaaS/feature.vue';
import coupons from '@/backend/pages/setting/SaaS/coupons.vue';
import filters from '@/mixins/filters.js';
import setmeal from '@/backend/services/account/setmeal.js';
import messageSwitch from '@/components/customer/messageSwitch';
import dialogForm from '@/components/dialogForm/dialogForm';
import subDatalist from '@/backend/pages/setting/SaaS/subDatalist';

let { money } = filters.filters;

export default {
	name: 'saas',
	data() {
		return {
			tabValue: 'setMeal',
			tabList: [
				{ label: '套餐配置', name: 'setMeal' },
				{ label: '功能配置', name: 'feature' },
				{ label: '自动优惠配置', name: 'coupons' },
			],
			setMealGroups: {},
			featureGroups: {},
			discountGroups: {},
			setMealColumn: [],
			featureColumn: [],
			discountColumn: [],
			dialogVisible: false,
			attributes: {},
			dialogData: [],
			dialogTotal: '',
			dialogColumn: [],

			//优惠
			preferentialPrice: '',
			preferentialAfterPrice: '',
		};
	},
	mounted() {
		this.setGroups();
		this.setColumn();
	},
	activated() {
		this.changeTab({ name: this.tabValue });
	},
	methods: {
		changeTab(val) {
			this.tabValue = val.name;
			this.setGroups();
			if (val.name == 'setMeal') {
				this.$refs.setmeal.query();
			}
			if (val.name == 'feature') {
				this.$refs.feature.query();
			}
			if (val.name == 'coupons') {
				this.$refs.coupons.query();
			}
		},
		setGroups() {
			this.setMealGroups = {
				others: [
					{
						tagName: 'sky-input',
						placeholder: '套餐名称',
						label: '套餐名称',
						prop: 'packageName',
						value: '',
					},
				],
				multiples: [
					{
						defaultText: '全部状态',
						placeholder: '全部状态',
						label: '状态',
						prop: 'isEnable',
						options: [
							{
								label: '启用状态',
								value: '1',
							},
							{
								label: '停用状态',
								value: '0',
							},
						],
						value: '1',
					},
				],
			};
			this.featureGroups = {
				others: [
					{
						tagName: 'sky-input',
						placeholder: '功能名称',
						label: '功能名称',
						prop: 'name',
						value: '',
					},
				],
				multiples: [
					{
						defaultText: '全部状态',
						placeholder: '全部状态',
						label: '状态',
						prop: 'isEnable',
						options: [
							{
								label: '启用状态',
								value: 1,
							},
							{
								label: '停用状态',
								value: 0,
							},
						],
						value: '',
					},
				],
			};
			this.discountGroups = {
				others: [
					{
						tagName: 'sky-input',
						placeholder: '优惠名称',
						label: '优惠名称',
						prop: 'name',
						value: '',
					},
				],
				multiples: [
					{
						defaultText: '全部状态',
						placeholder: '全部状态',
						label: '状态',
						prop: 'isEnable',
						options: [
							{
								label: '启用',
								value: true,
							},
							{
								label: '停用',
								value: false,
							},
						],
						value: '',
					},
				],
			};
		},
		setColumn() {
			let that = this;
			let setmealChildColumn = [
				{
					label: '',
					width: 300,
					align: 'center',
				},
				{
					label: '版本',
					bind: 'version',
				},
				{
					label: '优惠后总价',
					bind: 'priceList',
					type: 'arrayMultiLineShow',
					dataStyle: {
						'justify-content': 'flex-start',
					},
					iconName: 'chakan',
					dataStyle(val) {
						let { currency, price } = val;
						return money(price, currency, true);
					},
					async preview(val, row) {
						console.log(val, row);

						let { packageVersionId } = row;
						let { currency, preferentialAfterPrice, preferentialPrice, price } = val;

						// that.dialogData = val.functionItemList;

						await that.setMealFunctionItemLists(packageVersionId, currency);

						that.dialogTotal = money(price, currency);
						that.preferentialPrice = money(preferentialPrice, currency);
						that.preferentialAfterPrice = money(preferentialAfterPrice, currency);

						that.setDialogColumn();
						that.dialogVisible = true;
					},
				},
				{
					label: '备注',
					bind: 'remarks',
					type: 'popoverView',
				},
				// {
				// 	label: '允许续费',
				// 	bind: 'isAllowRenewal',
				// 	type: 'listSwitch',
				// 	align: 'center',
				// 	disabled: false,
				// 	style: {
				// 		display: 'flex',
				// 		'justify-content': 'center',
				// 	},
				// 	change(val, scoped) {
				// 		that.setRenew(scoped.row.id, setmeal.areRenewalsAllowed);
				// 	},
				// },
				{
					label: '',
					type: 'percentage',
					align: 'center',
					dataStyle() {
						return '-';
					},
				},
				{
					label: '操作',
					type: 'btnClick',
					align: 'center',
					style: 'text',
					bind: [
						{
							text: '重新启用',
							async trigger(row) {
								that.update(row, row.id, setmeal.setMealDetail, 'setmeal');
							},
						},
					],
				},
			];
			this.setMealColumn = [
				{
					type: 'mapping',
					mapType: 'iconfont',
					width: 50,
					parentEvent() {
						return 'yuan';
					},
					message(row) {
						return row.isEnable ? '启用' : '停用';
					},
					colors(row) {
						let color = row.isEnable ? '#67C23A' : '#999';
						return {
							color,
						};
					},
				},
				{
					label: '',
					type: 'tableExpand',
					width: 60,
					custom: true,
					tagName: subDatalist,
					columns: setmealChildColumn,
					ref: 'historyVersionList',
				},
				{
					label: '套餐名称',
					bind: 'packageName',
					type: 'popoverView',
				},
				{
					label: '版本',
					bind: 'version',
					width: 120,
				},
				{
					label: '优惠后总价',
					bind: 'priceList',
					type: 'arrayMultiLineShow',
					dataStyle: {
						'justify-content': 'flex-start',
					},
					iconName: 'chakan',
					dataStyle(val) {
						let { currency, preferentialAfterPrice } = val;
						return money(preferentialAfterPrice, currency, true);
					},
					preview: async (item, row) => {
						let { packageVersionId } = row;
						let { currency, preferentialAfterPrice, preferentialPrice, price } = item;

						await that.setMealFunctionItemLists(packageVersionId, currency);
						that.dialogTotal = money(price, currency);
						that.preferentialPrice = money(preferentialPrice, currency);
						that.preferentialAfterPrice = money(preferentialAfterPrice, currency);
						that.setDialogColumn();
						that.dialogVisible = true;
					},
				},
				{
					label: '备注',
					bind: 'remarks',
					type: 'popoverView',
				},
				{
					label: '允许新单',
					bind: 'flagNewOrder',
					type: 'listSwitch',
					align: 'center',
					disabled: false,
					style: {
						display: 'flex',
						'justify-content': 'center',
					},
					change(val, scoped) {
						that.newOrder(scoped.row);
					},
				},
				{
					label: '允许续费',
					bind: 'isAllowRenewal',
					type: 'listSwitch',
					align: 'center',
					disabled: false,
					style: {
						display: 'flex',
						'justify-content': 'center',
					},
					change(val, scoped) {
						that.setRenew(scoped.row.packageVersionId, setmeal.areRenewalsAllowed);
					},
					showBottomText(scoped) {
						let { flagRenewalWhiteList } = scoped.row;
						return flagRenewalWhiteList ? '白名单已开启' : '白名单已关闭';
					},
				},
				{
					label: '系统访问权限',
					type: 'custom',
					align: 'center',
					componentName: messageSwitch,
					inactiveValue: false,
					activeValue: true,
					async event(row) {
						try {
							await setmeal.enabledWechatPremission({ id: row.id });
							that.$message.success('更新状态成功');
							that.$refs.setmeal.query();
						} catch (error) {
							that.$message.warning('更新状态失败');
						}
					},
					bind: 'isEnableAppletPermissions',
				},
				{
					label: '操作',
					type: 'btnClick',
					align: 'center',
					style: 'text',
					bind(row) {
						let arr = [
							{
								text: '编辑',
								async trigger(row) {
									that.setMealUpdate(row.packageVersionId);
								},
							},
						];
						if (row.isEnable) {
							arr.push({
								text: '停用',
								trigger(row) {
									that.enabled(row.id, setmeal.setmealEnabled);
								},
							});
						} else {
							arr.push({
								text: '启用',
								trigger(row) {
									that.enabled(row.id, setmeal.setmealEnabled);
								},
							});
						}
						arr.push({
							text: '续费白名单',
							trigger(row) {
								let { packageVersionId, id, flagRenewalWhiteList } = row;
								that.$router.push({
									name: 'renewalWhitelist',
									query: {
										id,
										packageVersionId,
										flagRenewalWhiteList,
									},
								});
							},
						});
						return arr;
					},
				},
			];

			let featureChildColumn = [
				{
					label: '',
					width: 180,
					align: 'center',
				},
				{
					label: '版本号',
					bind: 'version',
					align: 'center',
					width: 180,
				},
				{
					label: '功能类型',
					bind: 'typeName',
				},
				{
					label: '挂靠权限',
					bind: 'affiliatedPermissionsName',
					align: 'center',
					type: 'popoverView',
				},
				{
					label: '入账期',
					bind: 'billingPeriodTypeName',
				},
				{
					label: '量/时间',
					bind: 'number',
					type: 'percentage',
					dataStyle(val, row) {
						return `${val}${row.unitName}`;
					},
				},
				{
					label: '价格',
					bind: 'priceList',
					type: 'percentage',
					width: 150,
					dataStyle(val) {
						let { currency, price } = val;
						return money(price, currency, true);
					},
				},
				{
					label: '服务费比例',
					bind: 'serviceChargeProportion',
					align: 'center',
				},
				{
					label: '税费比例',
					bind: 'taxesProportion',
					align: 'center',
				},
				{
					label: '前置功能',
					bind: 'preFunctionItem',
					align: 'center',
					type: 'mapping',
					mapType: 'text',
					trigger: 'hover',
					// type: "popoverView"
				},
				{
					label: '启用时间',
					bind: 'formatEnableTime',
					align: 'center',
					width: 150,
				},
				{
					label: '备注',
					bind: 'remarks',
					align: 'center',
					type: 'popoverView',
				},
				// {
				// 	label: '允许续费',
				// 	// bind: 'isAllowRenewal',
				// 	// type: 'listSwitch',
				// 	// align: 'center',
				// 	disabled: false,
				// 	style: {
				// 		display: 'flex',
				// 		'justify-content': 'center',
				// 	},
				// 	// change(val, scope) {
				// 	// 	that.setRenew(scope.row.id, setmeal.setRenew);
				// 	// },
				// },
				{
					label: '限制设定',
					bind: '',
					type: '',
				},
				{
					label: '操作',
					type: 'btnClick',
					align: 'center',
					style: 'text',
					bind: [
						{
							text: '重新启用',
							trigger(row) {
								that.update(row, row.id, setmeal.featureDetail, 'feature');
							},
						},
					],
				},
			];
			this.featureColumn = [
				{
					type: 'mapping',
					mapType: 'iconfont',
					width: 30,
					parentEvent() {
						return 'yuan';
					},
					message(row) {
						return row.isEnable ? '启用' : '停用';
					},
					colors(row) {
						let color = row.isEnable ? '#67C23A' : '#999';
						return {
							color,
						};
					},
				},
				{
					label: '',
					type: 'tableExpand',
					width: 20,
					custom: true,
					tagName: subDatalist,
					columns: featureChildColumn,
					bind: 'historyVersionList',
				},
				{
					label: '功能名称',
					bind: 'name',
					type: 'popoverView',
					width: 130,
				},
				{
					label: '版本号',
					bind: 'version',
					align: 'center',
					width: 180,
				},
				{
					label: '功能类型',
					bind: 'typeName',
				},
				{
					label: '挂靠权限',
					bind: 'affiliatedPermissionsName',
					align: 'center',
					type: 'popoverView',
				},
				{
					label: '入账期',
					bind: 'billingPeriodTypeName',
				},
				{
					label: '量/时间',
					bind: 'number',
					type: 'percentage',
					dataStyle(val, row) {
						return `${val}${row.unitName}`;
					},
				},
				{
					label: '价格',
					bind: 'priceList',
					type: 'percentage',
					width: 150,
					dataStyle(val) {
						let { currency, price } = val;
						return money(price, currency, true);
					},
				},
				{
					label: '服务费比例',
					bind: 'serviceChargeProportion',
					align: 'center',
				},
				{
					label: '税费比例',
					bind: 'taxesProportion',
					align: 'center',
				},
				{
					label: '前置功能',
					bind: 'preFunctionItem',
					align: 'center',
					type: 'mapping',
					mapType: 'text',
					trigger: 'hover',
					// type: "popoverView"
				},
				{
					label: '启用时间',
					bind: 'formatEnableTime',
					align: 'center',
					width: 150,
				},
				{
					label: '备注',
					bind: 'remarks',
					align: 'center',
					type: 'popoverView',
				},
				// {
				// 	label: '允许续费',
				// 	bind: 'isAllowRenewal',
				// 	type: 'listSwitch',
				// 	align: 'center',
				// 	disabled: false,
				// 	style: {
				// 		display: 'flex',
				// 		'justify-content': 'center',
				// 	},
				// 	change(val, scoped) {
				// 		that.setRenew(scoped.row.functionItemVersionId, setmeal.setRenew);
				// 	},
				// },
				{
					label: '限制设定',
					type: 'custom',
					componentName: leftControl,
				},
				{
					label: '操作',
					type: 'btnClick',
					align: 'center',
					style: 'text',
					bind(row) {
						let arr = [
							{
								text: '更新',
								async trigger(row) {
									that.update(row, row.functionItemVersionId, setmeal.featureDetail, 'feature');
								},
							},
						];
						if (row.isEnable) {
							arr.push({
								text: '停用',
								trigger(row) {
									that.enabled(row.id, setmeal.featureEnabled);
								},
							});
							return arr;
						} else {
							arr.push({
								text: '启用',
								trigger(row) {
									that.enabled(row.id, setmeal.featureEnabled);
								},
							});
							return arr;
						}
					},
				},
			];

			this.discountColumn = [
				{
					type: 'mapping',
					mapType: 'iconfont',
					width: 50,
					parentEvent() {
						return 'yuan';
					},
					message(row) {
						return row.isEnable ? '启用' : '停用';
					},
					colors(row) {
						let color = row.isEnable ? '#67C23A' : '#999';
						return {
							color,
						};
					},
				},
				{
					label: '优惠名称',
					bind: 'name',
					// align: 'center',
					type: 'mapping',
					mapType: 'text',
					trigger: 'hover',
				},
				{
					label: '套餐名称',
					bind: 'packageName',
					// align: 'center',
					type: 'mapping',
					mapType: 'text',
					trigger: 'hover',
				},
				{
					label: '自动优惠功能',
					bind: 'functionList',
					type: 'columns',
					componentName: 'multiseriate',
					multi: true,
					dataList(val) {
						let data = val.map(item => {
							return {
								value: `${item.name} * ${item.bigGiftNumber}/${item.unitName}`,
							};
						});
						return data;
					},
					multiseriate(val) {
						let data = val.map(item => {
							return {
								one: [
									{
										value: item.name,
										style: {
											'justify-content': 'flex-start',
										},
									},
								],
								two: [
									{
										value: item.functionItemVersionId,
									},
								],
							};
						});
						data.unshift({
							one: [
								{
									value: '功能名称',
									style: {
										'justify-content': 'flex-start',
										'font-weight': 'bold',
										'font-size': '16px',
									},
								},
							],
							two: [
								{
									value: '版本',
									style: {
										'font-weight': 'bold',
										'font-size': '16px',
									},
								},
							],
						});
						return data;
					},
				},
				{
					label: '优惠金额',
					showOverflowTooltip: true,
					bind: (row, index) => {
						let { price, currency } = row;
						return money(price, currency, true);
					},
				},
				{
					label: '备注',
					bind: 'remarks',
					// align: 'center',
					type: 'mapping',
					mapType: 'text',
					trigger: 'hover',
				},
				{
					label: '新单/续费',
					bind: row => {
						let { orderType } = row;
						return orderType === 1 ? '新单' : '续费';
					},
				},
				{
					label: '操作',
					type: 'btnClick',
					style: 'text',
					bind(row) {
						let arr = [
							{
								text: '复制',
								async trigger(row) {
									that.couponsUpdate(row.id, 'copy');
								},
							},
							{
								text: '编辑',
								async trigger(row) {
									that.couponsUpdate(row.id, 'edit');
								},
							},
						];
						if (row.isEnable) {
							arr.push({
								text: '停用',
								trigger(row) {
									that.enabled(row.id, setmeal.couponsIsEnabled);
								},
							});
							return arr;
						} else {
							arr.push({
								text: '启用',
								trigger(row) {
									that.enabled(row.id, setmeal.couponsIsEnabled);
								},
							});
							return arr;
						}
					},
				},
			];
		},
		// 是否续费
		async setRenew(id, api) {
			try {
				await api({ id });
				this.$message({
					message: '修改成功',
					type: 'success',
				});
				this.$refs.feature && this.$refs.feature.query();
				this.$refs.setmeal && this.$refs.setmeal.query();
			} catch (error) {
				this.$message({
					message: '修改失败',
					type: 'warning',
				});
			}
		},
		// 是否允许新单
		async newOrder(row) {
			try {
				let { id } = row;
				await setmeal.allowNewOrder({
					id,
				});
				this.$refs.setmeal && this.$refs.setmeal.query();
			} catch (error) {
				this.$message({
					message: '修改失败',
					type: 'warning',
				});
			}
		},
		// 更新
		async update(row, id, api, type) {
			console.log(id);
			let res = await api(id);
			await this.$refs[type].getActiveFeatureList(res.data, id);
		},
		// 编辑套餐
		async setMealUpdate(id) {
			this.$router.push({
				name: 'setMealConfig',
				query: {
					id,
				},
			});
		},
		// 编辑自动优惠
		async couponsUpdate(id, type) {
			this.$router.push({
				name: 'couponsConfig',
				query: {
					id,
					type,
				},
			});
		},
		// 是否启用
		async enabled(id, api) {
			try {
				await api({ id });
				this.$message({
					message: '修改成功',
					type: 'success',
				});
				this.$refs.setmeal && this.$refs.setmeal.query();
				this.$refs.feature && this.$refs.feature.query();
				this.$refs.coupons && this.$refs.coupons.query();
			} catch (err) {
				this.$message({
					message: '修改失败',
					type: 'warning',
				});
			}
		},
		// 套餐价格column
		setDialogColumn() {
			this.dialogColumn = [
				{
					label: '功能名称',
					bind: 'name',
					type: 'mapping',
					mapType: 'text',
					trigger: 'hover',
					multidataMapping: row => {
						let { name } = row;
						return name;
					},
				},
				{
					label: '版本号',
					bind: 'version',
					type: 'percentage',
					dataStyle(val) {
						return val;
					},
				},
				{
					label: '价格',
					bind: 'price',
					type: 'percentage',
					dataStyle(val, row) {
						let { currency } = row;
						return money(val, currency);
					},
				},
				{
					label: '量/时间',
					bind: 'number',
					type: 'percentage',
					dataStyle(val, row) {
						return `${val}${row.unitName}`;
					},
				},
				{
					label: '总价',
					bind: 'singleFunctionTotalPrice',
					type: 'percentage',
					dataStyle(val, row) {
						let { currency } = row;
						return money(val, currency);
					},
				},
				{
					label: '优惠',
					bind: 'preferentialPrice',
					type: 'percentage',
					dataStyle(val, row) {
						let { currency } = row;
						return money(val, currency);
					},
				},
				{
					label: '优惠后价格',
					bind: 'afterDiscount',
					type: 'percentage',
					dataStyle(_val, row) {
						let { currency, singleFunctionTotalPrice, preferentialPrice } = row;
						return money(singleFunctionTotalPrice - preferentialPrice, currency);
					},
				},
				{
					label: '服务费',
					bind: 'functionTotalServiceFee',
					type: 'percentage',
					dataStyle(val, row) {
						let { currency } = row;

						if (val == 0) {
							return '-';
						} else {
							return money(val, currency);
						}
					},
				},
				{
					label: '税费',
					bind: 'functionTotalTaxFee',
					type: 'percentage',
					dataStyle(val, row) {
						let { currency } = row;

						if (val == 0) {
							return '-';
						} else {
							return money(val, currency);
						}
					},
				},
				{
					label: '实际充值',
					bind: 'functionTotalPrice',
					type: 'percentage',
					dataStyle(val, row) {
						let {
							functionTotalServiceFee: serviceFee,
							functionTotalTaxFee: taxFee,
							currency,
						} = row;
						if (serviceFee == 0 || taxFee == 0) {
							return '-';
						} else {
							return money(val - serviceFee - taxFee, currency);
						}
					},
				},
			];
		},
		async setMealFunctionItemLists(packageVersionId, currency) {
			let res = await setmeal.setMealFunctionItemLists({ packageVersionId, currency });
			this.dialogData = res.data;
		},
	},
	components: { skyTabs, barCard, setMeal, feature, dialogForm, coupons },
};
</script>

<style lang="scss" scoped>
.dialog-total {
	width: 100%;
	padding-top: 20px;
	border-top: 1px dashed #666;
	text-align: right;
	font-weight: bold;

	span {
		margin-left: 20px;
	}
}
</style>
